import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  FETCH_PROJECT,
  UPDATE_PROJECT_STARTED,
  SELECT_INDEX_TYPE,
  CREATE_QUESTION,
  DELETE_QUESTION,
  UPDATE_ALL_QUESTIONS,
  CHANGE_PROJECT_TITLE,
  SHOW_QUIZ_START_MODAL,
  HIDE_QUIZ_START_MODAL,
  SHOW_IMAGE_UPLOAD_MODAL,
  HIDE_IMAGE_UPLOAD_MODAL,
  SHOW_EDITOR_HEADER_MENU,
  HIDE_EDITOR_HEADER_MENU,
  LOG_OUT,
  CHANGE_QUESTION_INDEX,
  RESET_PROJECT,
  GET_RANKING_DATA,
  GET_IS_FETCHABLE_RANKING_DATA
} from '../../actions/editorActions'
import EditorInput from '../../components/organisms/EditorInput/EditorInput'
import EditorHeader from '../../components/organisms/EditorHeader/EditorHeader'
import EditorFooter from '../../components/organisms/EditorFooter/EditorFooter'
import EditorPreview from '../../components/organisms/EditorPreview/EditorPreview'
import SpinnerWithLabel from '../../components/molecules/SpinnerWithLabel/SpinnerWithLabel'
import './EditorPage.css'
import { NO_IMAGE_URL, LP_IMAGE_URL } from '../../../commons/Const'
import ModalError from '../../components/organisms/ModalError/ModalError'
import { MemberStatus, QuizType } from '../../../commons/EditorStatus'
import { noticeQuizStartToSlack } from '../../../commons/Slack'
import { Plan } from '../../../commons/Plan'

class EditorPage extends PureComponent {
  componentDidMount() {
    this.props.fetchProject()
  }

  render() {
    const {
      project,
      currentEditIndex,
      editorIndex,
      selectIndexAndType,
      quizType,
      lastUpdatedAt,
      addQuestion,
      deleteQuestion,
      changeProjectTitle,
      canIntervalUpdate,
      updateAllQuestions,
      showImageUploadModal,
      hideImageUploadModal,
      isQuizStartModalShow,
      showQuizStartModal,
      hideQuizStartModal,
      isImageUploadModalShow,
      imageUploadTargetIndex,
      showEditorHeaderMenu,
      hideEditorHeaderMenu,
      isEditorHeaderMenuShow,
      isLoading,
      handleLogOut,
      errorMessage,
      handleChangeQuestionIndex,
      updateProjectStarted,
      resetProject,
      memberId,
      getRankingData,
      getIsFetchableRankingData,
      isFetchableRankingData
    } = this.props

    if (!project) {
      return (
        <div styleName="spinner">
          <SpinnerWithLabel />
        </div>
      )
    }

    let status = MemberStatus.GUEST
    if (project.login) {
      status = project.paid ? MemberStatus.PAID : MemberStatus.MEMBER
    }

    const nowQuestion = project.questions[currentEditIndex]

    // refs. https://github.com/you12724/ennoshita/issues/737
    if (nowQuestion === undefined && currentEditIndex !== 0) {
      selectIndexAndType(0, QuizType.FIRSTPAGE.value)
      return null
    }

    const handleChangeProjectStarted = started => {
      updateProjectStarted({
        started,
        id: project.id
      })
    }

    const handleClickOpenPresentationWindow = () => {
      if (
        window.confirm(
          '前回の参加者のデータをリセットしますか？\n\n参加者の名前、回答、スライドの進行状況をリセットできます。登録済の参加者の名前や回答ランキングのデータを残したい場合は「キャンセル」を選んでください。'
        )
      ) {
        resetProject()
        if (process.env.STAGE === 'production') {
          noticeQuizStartToSlack(
            '#notify_events',
            memberId,
            project.id,
            Plan.info(project.plan).name,
            'リセットした',
            project.project_title,
            project.presentation_title
          )
        }
        return
      }
      window.open('presentation', 'presentation', 'width=960,height=720')
      if (process.env.STAGE === 'production') {
        noticeQuizStartToSlack(
          '#notify_events',
          memberId,
          project.id,
          Plan.info(project.plan).name,
          'リセットしていない',
          project.project_title,
          project.presentation_title
        )
      }
    }

    const handleDownloadRankingData = () => {
      if (window.confirm('ランキングデータをダウンロードしますか？')) {
        getRankingData(project.id)
      }
    }

    const handleShowQuizModal = () => {
      getIsFetchableRankingData(project.id)
      showQuizStartModal()
    }

    return (
      <div styleName="container">
        <div styleName="header">
          <EditorHeader
            projectTitle={project.project_title}
            onChangeProjectTitleText={changeProjectTitle}
            handleLogOut={handleLogOut}
            isModalShow={isQuizStartModalShow}
            showModal={handleShowQuizModal}
            hideModal={hideQuizStartModal}
            showMenu={showEditorHeaderMenu}
            hideMenu={hideEditorHeaderMenu}
            isMenuShow={isEditorHeaderMenuShow}
            shareParam={project.share_param}
            isStarted={project.is_started}
            status={status}
            plan={project.plan}
            expireDate={project.expire_date}
            handleChangeProjectStarted={handleChangeProjectStarted}
            handleClickOpenPresentationWindow={handleClickOpenPresentationWindow}
            handleDownloadRankingData={handleDownloadRankingData}
            handleReadyRankingData={getIsFetchableRankingData}
            isFetchableRankingData={isFetchableRankingData}
          />
        </div>
        <div styleName="body">
          <div styleName="bodyContainer">
            {project.questions.length === 0 ? (
              <div styleName="noQuestionMessage">
                <p>問題が一問もありません。フッターメニューから問題を追加しましょう！</p>
              </div>
            ) : (
              <>
                <div styleName="preview">
                  <EditorPreview
                    eventTitle={project.presentation_title}
                    eventImage={project.image || LP_IMAGE_URL}
                    question={nowQuestion}
                    index={currentEditIndex + 1}
                    type={quizType}
                    canIntervalUpdate={canIntervalUpdate}
                    updateQuestions={updateAllQuestions}
                    lastUpdateTime={lastUpdatedAt || project.updated_at}
                  />
                </div>
                <div styleName="editor">
                  <EditorInput
                    project={project}
                    currentEditIndex={currentEditIndex}
                    answers={project.questions[currentEditIndex].choices}
                    editorIndex={editorIndex}
                    quizType={quizType}
                    rankingConfig={project.ranking_count}
                    showImageUploadModal={showImageUploadModal}
                    hideImageUploadModal={hideImageUploadModal}
                    isModalShow={isImageUploadModalShow}
                    imageUploadTargetIndex={imageUploadTargetIndex}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div styleName="footer">
          <EditorFooter
            projectTitle={project.presentation_title}
            projectImageUrl={project.image || NO_IMAGE_URL}
            handleSelect={selectIndexAndType}
            projectId={project.id}
            handleAddQuestion={() => addQuestion({ projectId: project.id, newIndex: project.questions.length + 1 })}
            handleDeleteQuestion={deleteQuestion}
            questions={project.questions}
            selectedIndex={currentEditIndex}
            selectedType={quizType}
            handleChangeQuestionIndex={handleChangeQuestionIndex}
          />
        </div>
        {isLoading ? (
          <div styleName="loadingOverlay">
            <div styleName="loadingPopup">
              <SpinnerWithLabel />
            </div>
          </div>
        ) : null}
        {errorMessage ? <ModalError message={errorMessage} /> : null}
      </div>
    )
  }
}

EditorPage.propTypes = {
  project: PropTypes.object,
  currentEditIndex: PropTypes.number,
  editorIndex: PropTypes.number,
  fetchProject: PropTypes.func,
  resetProject: PropTypes.func,
  updateProjectStarted: PropTypes.func.isRequired,
  selectIndexAndType: PropTypes.func.isRequired,
  quizType: PropTypes.number,
  addQuestion: PropTypes.func.isRequired,
  deleteQuestion: PropTypes.func.isRequired,
  updateAllQuestions: PropTypes.func.isRequired,
  canIntervalUpdate: PropTypes.bool.isRequired,
  changeProjectTitle: PropTypes.func.isRequired,
  showQuizStartModal: PropTypes.func.isRequired,
  hideQuizStartModal: PropTypes.func.isRequired,
  showImageUploadModal: PropTypes.func.isRequired,
  hideImageUploadModal: PropTypes.func.isRequired,
  isQuizStartModalShow: PropTypes.bool.isRequired,
  isImageUploadModalShow: PropTypes.bool.isRequired,
  imageUploadTargetIndex: PropTypes.number.isRequired,
  isEditorHeaderMenuShow: PropTypes.bool.isRequired,
  showEditorHeaderMenu: PropTypes.func.isRequired,
  hideEditorHeaderMenu: PropTypes.func.isRequired,
  lastUpdatedAt: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  handleLogOut: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  handleChangeQuestionIndex: PropTypes.func.isRequired,
  memberId: PropTypes.number,
  getRankingData: PropTypes.func.isRequired,
  getIsFetchableRankingData: PropTypes.func.isRequired,
  isFetchableRankingData: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    project: state.editor.project,
    currentEditIndex: state.editor.currentEditIndex,
    editorIndex: state.editor.editorIndex,
    quizType: state.editor.quizType,
    canIntervalUpdate: state.editor.canIntervalUpdate,
    isQuizStartModalShow: state.editor.isQuizStartModalShow,
    isImageUploadModalShow: state.editor.isImageUploadModalShow,
    isEditorHeaderMenuShow: state.editor.isEditorHeaderMenuShow,
    imageUploadTargetIndex: state.editor.imageUploadTargetIndex,
    lastUpdatedAt: state.editor.lastUpdatedAt,
    isLoading: state.editor.isLoading,
    errorMessage: state.editor.errorMessage,
    memberId: state.auth.currentUserId,
    isFetchableRankingData: state.editor.isFetchableRankingData
  }
}
const mapDispatchToProps = dispatch => ({
  fetchProject: () => dispatch(FETCH_PROJECT()),
  updateProjectStarted: params => dispatch(UPDATE_PROJECT_STARTED(params)),
  resetProject: () => dispatch(RESET_PROJECT()),
  selectIndexAndType: (index, type) => dispatch(SELECT_INDEX_TYPE({ index: index, type: type })),
  addQuestion: data => dispatch(CREATE_QUESTION(data)),
  deleteQuestion: data => dispatch(DELETE_QUESTION(data)),
  changeProjectTitle: text => dispatch(CHANGE_PROJECT_TITLE(text)),
  updateAllQuestions: () => dispatch(UPDATE_ALL_QUESTIONS()),
  showQuizStartModal: () => dispatch(SHOW_QUIZ_START_MODAL()),
  hideQuizStartModal: () => dispatch(HIDE_QUIZ_START_MODAL()),
  showImageUploadModal: target => dispatch(SHOW_IMAGE_UPLOAD_MODAL(target)),
  hideImageUploadModal: target => dispatch(HIDE_IMAGE_UPLOAD_MODAL(target)),
  showEditorHeaderMenu: () => dispatch(SHOW_EDITOR_HEADER_MENU()),
  hideEditorHeaderMenu: () => dispatch(HIDE_EDITOR_HEADER_MENU()),
  handleLogOut: () => dispatch(LOG_OUT()),
  handleChangeQuestionIndex: data => dispatch(CHANGE_QUESTION_INDEX(data)),
  getRankingData: data => dispatch(GET_RANKING_DATA(data)),
  getIsFetchableRankingData: data => dispatch(GET_IS_FETCHABLE_RANKING_DATA(data))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditorPage)
